import { Routes, Route, useLocation } from 'react-router-dom'
import { ErrorBoundary } from '@praxis/component-logging'

import { ErrorContent } from '../globalComponents/ErrorContent'
import { RegularFileSubWrapper } from '../views/RegularFileSub'

export const MainRouter = () => {
  const location = useLocation()
  return (
    <ErrorBoundary key={location.pathname} FallbackComponent={ErrorContent}>
      <Routes>
        <Route path="/" element={<RegularFileSubWrapper />}></Route>
      </Routes>
    </ErrorBoundary>
  )
}
